import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Grid, Paper } from '@mui/material';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AdaptContent from '../../../static/svgs/AdaptContent.svg';
import CollabContent from '../../../static/svgs/CollabContent.svg';
import CommContent from '../../../static/svgs/CommContent.svg';
import CritContent from '../../../static/svgs/CritContent.svg';
import EmpContent from '../../../static/svgs/EmpContent.svg';
import LearnerContent from '../../../static/svgs/LearnerContent.svg';
import PersonalContent from '../../../static/svgs/PersonalContent.svg';
import { ReactComponent as AdaptIcon } from '../../../static/svgs/AdaptIcon.svg';
import { ReactComponent as CollabIcon } from '../../../static/svgs/CollabIcon.svg';
import { ReactComponent as CommIcon } from '../../../static/svgs/CommIcon.svg';
import { ReactComponent as CritIcon } from '../../../static/svgs/CritIcon.svg';
import { ReactComponent as EmpIcon } from '../../../static/svgs/EmpIcon.svg';
import { ReactComponent as LearnIcon } from '../../../static/svgs/LearnIcon.svg';
import { ReactComponent as PersonalIcon } from '../../../static/svgs/PersonalIcon.svg';
import { ReactComponent as ResourceIcon } from '../../../static/svgs/ResourceIcon.svg';

const tabsContentIcon = [
  { iconImage: <AdaptIcon />, contentImage: AdaptContent },
  { iconImage: <CollabIcon />, contentImage: CollabContent },
  { iconImage: <CommIcon />, contentImage: CommContent },
  { iconImage: <CritIcon />, contentImage: CritContent },
  { iconImage: <EmpIcon />, contentImage: EmpContent },
  { iconImage: <LearnIcon />, contentImage: LearnerContent },
  { iconImage: <PersonalIcon />, contentImage: PersonalContent },
];

const tabs = [
  { label: 'Adaptability', content: ["SubTask 1", "SubTask 2"], color: 'rgba(248, 248, 231, 1)', bgcolor: 'rgba(145, 149, 15, 1)' },
  { label: 'Collaboration', content: ["SubTask 1", "SubTask 2"], color: 'rgba(242, 252, 251, 1)', bgcolor: 'rgba(0, 153, 150, 1)' },
  { label: 'Communication', content: ["SubTask 1", "SubTask 2"], color: 'rgba(255, 243, 238, 1)', bgcolor: 'rgba(255, 136, 83, 1)' },
  { label: 'Critical Thinking', content: ["SubTask 1", "SubTask 2"], color: 'rgba(240, 234, 247, 1)', bgcolor: 'rgba(112, 51, 183, 1)' },
  { label: 'Empathy', content: ["SubTask 1", "SubTask 2"], color: 'rgba(237, 251, 255, 1)', bgcolor: 'rgba(77, 211, 254, 1)' },
  { label: 'Learner’s Mindset', content: ["SubTask 1", "SubTask 2"], color: 'rgba(249, 230, 242, 1)', bgcolor: 'rgba(201, 13, 129, 1)' },
  { label: 'Personal Responsibility', content: ["SubTask 1", "SubTask 2"], color: 'rgba(255, 248, 236, 1)', bgcolor: 'rgba(255, 191, 73, 1)' },
];

export default function NewSkillsPage({ skillsData }: any) {
  const [activeTab, setActiveTab] = useState(0);
  const [buttonState, setButtonState] = useState<Record<number, boolean>>({});
  const areas = skillsData?.areas;

  const handleButtonClick = (id: number) => {
    setButtonState((prevState: any) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleTab = (index: number) => {
    setButtonState({});
    setActiveTab(index);
  };

  if (!skillsData || !areas || areas.length === 0 || !tabs[activeTab] || !areas[activeTab]) {
    return <Typography sx={{ padding: '24px' }}>No skills data available or selected tab is invalid.</Typography>;
  }

  return (
    <Box sx={{ width: '100%', minHeight: '100vh' }}>
      <Box sx={{ height: '20px' }} />

      <Paper elevation={2} sx={{ width: '100%', height: 'auto', display:'block', mb:4 }}>
        {/* Tabs */}
        <Box sx={{ display: 'flex', borderBottom: 1, borderColor: 'divider', height: '57px', alignItems: 'flex-end' }}>
          {areas.map((tab: any, index: number) => {
            const isActive = activeTab === index;
            return (
              <Button
                key={tab.id || index}
                startIcon={tabsContentIcon[index]?.iconImage}
                sx={{
                  flexGrow: 1,
                  borderRadius: 0,
                  border: isActive ? `2px solid ${tabs[index]?.bgcolor}` : '2px solid transparent',
                  bgcolor: isActive ? tabs[index]?.color : 'transparent',
                  height: isActive ? '65px' : '57px',
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  color: 'rgba(7, 27, 34, 1)',
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '14px',
                  boxShadow: isActive ? 1 : 'none',
                  transition: 'all 0.2s ease',
                  whiteSpace: {
                    xs: 'normal',
                    md: 'normal',
                    lg: 'nowrap'
                  },
                  textAlign: {
                    xs: 'center',
                    md: 'center'
                  },
                  overflowWrap: 'break-word',
                  cursor: 'default',
                }}
              >
                <span
                  role="button"
                  tabIndex={0}
                  onClick={() => handleTab(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault(); // Prevent scrolling on Space
                      handleTab(index);
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {tab.title}
                </span>
              </Button>
            );
          })}
        </Box>

        <Grid container columns={5} paddingLeft={'40px'}>
          {/* Left: 3/5 */}
          <Grid xs={3} sx={{ p: 2, padding: '20px' }}>
            <Box display={'flex'} paddingBottom={'24px'}>
              {tabsContentIcon[activeTab] && (
                <Box sx={{ flexShrink: 0, width: 107, height: 107 }}>
                  <img src={tabsContentIcon[activeTab].contentImage} height={107} width={107} alt="Skill Icon" />
                </Box>
              )}
              <Box paddingLeft={'32px'}>
                {areas[activeTab] && (
                  <>
                    <Typography sx={{ fontWeight: '600', fontSize: '24px', fontFamily: 'Open Sans' }}>
                      {areas[activeTab]?.title}
                    </Typography>
                    <Typography mt={1}>
                      {areas[activeTab]?.description?.split('\r\n').map((line: string, index: number) => (
                        <div key={index} style={{ lineHeight: 1.4, marginBottom: 4 }}>
                          {line}
                        </div>
                      ))}
                    </Typography>
                  </>
                )}
              </Box>
            </Box>

            {areas[activeTab]?.credits?.map((credit: any, i: number) => (
              <Accordion
                key={i}
                sx={{
                  border: '1px solid #ccc',
                  borderTop: 'none',
                  borderLeft: 'none',
                  borderRight: 'none',
                  boxShadow: 'none',
                  marginBottom: '16px',
                  '&:before': {
                    display: 'none',
                  },
                }}
                expanded={!!buttonState[i]}
              >
                <AccordionSummary onClick={() => handleButtonClick(i)} expandIcon={buttonState[i] ? <RemoveIcon /> : <AddIcon />}>
                  <Typography sx={{ fontWeight: '600', fontSize: '16px', fontFamily: 'Open Sans' }}>{credit.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {credit?.description?.split('\r\n').map((line: string, index: number) => (
                      <div key={index} style={{ lineHeight: 1.4, marginBottom: 4 }}>
                        {line}
                      </div>
                    ))}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>

          {/* Right: 2/5 */}
          <Grid xs={2} sx={{ bgcolor: tabs[activeTab]?.color, pl: '40px', pt: '40px' }}>
            {areas[activeTab]?.files?.length > 0 && (
              <>
                <Typography sx={{ fontWeight: '600', fontSize: '16px', fontFamily: 'Open Sans' }}>Resources:</Typography>
                <Box sx={{ paddingTop: '24px', gap: '4' }}>
                  {areas[activeTab].files.map((file: any, i: number) => (
                    <Button
                      key={i}
                      onClick={() => window.open(file?.fileUrl, '_blank')}
                      sx={{
                        minHeight: "40px",
                        color: "rgba(7, 27, 34, 1)",
                        borderColor: "rgba(7, 27, 34, 1)",
                        borderRadius: '16px',
                        border: '2px solid rgba(7, 27, 34, 1)',
                        backgroundColor: 'white',
                        fontWeight: '600',
                        fontSize: '14px',
                        mb: 4,
                        ml: 2,
                        wordBreak: "break-all",
                      }}
                      startIcon={<ResourceIcon />}
                    >
                      {file?.name.length > 50 ? file.name.slice(0, 50) + '...' : file.name}
                    </Button>
                  ))}
                </Box>
              </>
            )}
            {/* <Typography sx={{ fontWeight: '600', fontSize: '16px', fontFamily: 'Open Sans', mt: '48px' }}>Available Activities for Enhancement:</Typography>
            <Box sx={{ paddingTop: '24px' }}>
              <Button
                // variant="outlined"
                // size="small"
                // onClick={}
                sx={{
                  maxHeight: "40px",
                  color: "rgba(7, 27, 34, 1)",
                  borderColor: "rgba(7, 27, 34, 1)",
                  borderRadius: '16px',
                  border: '2px solid rgba(7, 27, 34, 1)',
                  backgroundColor: 'white',
                  fontWeight: '600', fontSize: '14px'
                }}
                startIcon={<ResourceIcon />}
              >
                Puzzle Solving
              </Button>
            </Box> */}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
